var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M43.6662791,30.318352 L25.0756019,9.56568369 C24.4697364,8.88767729 23.6033251,8.5 22.7001729,8.5 C21.9124387,8.5 21.1561348,8.79197133 20.5659518,9.32596193 C19.2445536,10.5208062 19.1362577,12.5937171 20.3274793,13.9254287 L36.9654413,32.4996243 L20.3276725,51.0763262 C19.1364577,52.4064875 19.2447392,54.4786416 20.5659518,55.673318 L20.6273575,55.7282436 L20.7454056,55.8275085 C21.2945697,56.2585271 21.9501158,56.491919 22.6374431,56.5 L22.8676269,56.4943108 C23.7260941,56.4486343 24.5012066,56.0775837 25.0753797,55.4366812 L43.6657258,34.6786504 C44.7779992,33.4361715 44.7779992,31.5619631 43.6662791,30.318352 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.0518ee2a5846a7763a682fbd1ec8e5e9.svg";
export { ForwardRef as ReactComponent };